
























import _ from 'lodash'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import * as ApiPath from '@/tcw/constant/ApiPath'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import ShouninRouteStep from './ShouninRouteStep.vue'
import { TCWBadDataStructureError } from '@/plugins/TCWBaseError'
import { UserSession } from '@/tcw/api/types'

class UserGetComponent extends DataGetComponent<UserSession[]> {}

@Component({
  components: { ShouninRouteStep }
})
export default class UserSelectDialog extends Mixins(UserGetComponent) {
  @Prop({ type: Boolean, default: true })
  private dialogOpen = false

  @Emit()
  private select(_userId: number, _userInfo: UserSession) {
    //
  }
  @Emit()
  private close() {
    //
  }

  private get direction() {
    return this.isMobile ? 'btt' : 'rtl'
  }
  private get size() {
    return this.isMobile ? '90%' : '50%'
  }

  private userList: UserSession[] = []

  get apiPath(): string {
    return ApiPath.Paths.User.get
  }

  protected responseInitWebApi(response: UserSession[]): void {
    if (_.isArray(response)) {
      this.userList = response.sort((a, b) => {
        const shozokuA = a.shozokuCode ? a.shozokuCode : ''
        const shozokuB = b.shozokuCode ? b.shozokuCode : ''
        if (shozokuA !== shozokuB) {
          return shozokuA > shozokuB ? 1 : -1
        }
        const shokuiA = a.shokuiCode ? a.shokuiCode : ''
        const shokuiB = b.shokuiCode ? b.shokuiCode : ''
        if (shokuiA !== shokuiB) {
          return shokuiA < shokuiB ? 1 : -1
        }
        const userB = b.id ? b.id : ''
        return shokuiA >= userB ? 1 : -1
      })
    } else {
      throw new TCWBadDataStructureError(
        'データ構造が不正です。システム管理者に問い合わせてください'
      )
    }
  }
}
